import { render, staticRenderFns } from "./Comparsion.vue?vue&type=template&id=63ae37fc&"
import script from "./Comparsion.vue?vue&type=script&lang=js&"
export * from "./Comparsion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports